import { HttpContextToken, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { finalize } from 'rxjs/operators';
import { SpinnerService } from './spinner.service';

// example of how to exclude
// getDataWithoutSpinner(): Observable<any> {
//   return this.http.get('/api/some-data', {
//     context: new HttpContext().set(BYPASS_SPINNER, true),
//   });
// }

// Create a new context token to indicate if the spinner should be excluded.
export const BYPASS_SPINNER = new HttpContextToken<boolean>(() => false);

export const spinnerInterceptor: HttpInterceptorFn = (req, next) => {
  const spinner = inject(SpinnerService);

  // Check if the BYPASS_SPINNER context token is set to true.
  if (req.context.get(BYPASS_SPINNER)) {
    // If it is, bypass the spinner and proceed with the request.
    return next(req);
  }

  // Otherwise, show the spinner and handle the request normally.
  spinner.show();
  return next(req).pipe(finalize(() => spinner.hide()));
};
